export enum MessageConnectionType {
  WEBSOCKET = 'WEBSOCKET',
  STREAMING = 'STREAMING',
  POLLING = 'POLLING',
}
